<template>
  <div class="w-full px-3 py-2 border border-[#EFEFEF] rounded-md">
    <div
      class="flex justify-between items-center font-primary text-[14px] leading-[16px] text-black mb-2.5"
    >
      <div v-if="isCreated">Created</div>
      <div v-else-if="isTransfer">Transferred</div>
      <template v-else-if="isSale">
        <div class="flex items-center">
          <div class="mr-1">Sold for</div>
          <div class="font-medium text-gray-800">{{ price }}</div>
        </div>
      </template>
      <div class="flex items-center cursor-pointer" @click="handleTxHashClick">
        <div class="mr-1.5">
          {{ formatTimestamp(transaction.timestamp, { formatString }) }}
        </div>
        <Icon :size="14" name="External" class="stroke-gray-800" />
      </div>
    </div>

    <div class="flex items-center">
      <template v-if="props.transaction.from">
        <div class="w-1/2 flex items-center">
          <img
            class="w-[30px] h-[30px] rounded-full mr-2.5"
            :src="props.transaction.from.avatarUrl"
          />
          <div class="font-primary text-[14px] leading-[16px] text-black">
            {{ props.transaction.from.name }}
          </div>
        </div>
        <Icon
          :size="18"
          name="ArrowUp"
          class="rotate-90 mx-5 stroke-gray-800"
        />
      </template>
      <div class="w-1/2 flex items-center">
        <img
          class="w-[30px] h-[30px] rounded-full mr-2.5"
          :src="props.transaction.to.avatarUrl"
        />
        <div class="font-primary text-[14px] leading-[16px] text-black">
          {{ props.transaction.to.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@dacr/ui'
import {
  TransactionStatus,
  type Transaction,
} from '@/shared/graphql/legacy/generated'
import { useUserStore } from '@/shared/stores/user'
import { formatTimestamp } from '@/shared/utils/datetime'
import { formatPrice } from '@/shared/utils/money'
import { computed } from 'vue'

const props = defineProps<{
  transaction: Transaction
}>()

const userStore = useUserStore()

const formatString = computed(() =>
  userStore.user ? userStore.user.dateFormat : 'M/d/yyyy'
)

const isCreated = props.transaction.status === TransactionStatus.Created
const isTransfer = props.transaction.status === TransactionStatus.Transferred
const isSale = props.transaction.status === TransactionStatus.Sold

const price = computed(() => {
  return formatPrice({
    amount: props.transaction.price?.value || 0,
    currency: props.transaction.price?.currency,
  })
})

const handleTxHashClick = () => {
  window.open(props.transaction.url)
}
</script>
